import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { Row, Col, CardBody, Card } from 'reactstrap';
import PropTypes from 'prop-types';
import qs from 'qs';
import InfiniteScroll from 'react-infinite-scroller';
import _ from 'lodash';

import Image from 'flaivy-react/components/Image';
import SearchNoResult from './SearchNoResult';
import getAxiosInstance from '../config/api';

const getBrands = async (querySpecification, page, req) => {
  const query = qs.stringify({ query: querySpecification, page, sort: 'name' });
  const axiosInstance = await getAxiosInstance(req);
  const response = await axiosInstance.get(`/public/brands?${query}`);
  return response.data;
};

function Brands({ initialBrands }) {
  const [state, setState] = useState({
    brands: initialBrands.rows,
    infiniteScroll: {
      currentPage: 1,
      nrOfPages: initialBrands.totalPages,
      hasMore: true,
    },
  });
  const loadMoreBrands = async (filterParams, page) => {
    const data = await getBrands(filterParams, page);
    setState({
      brands: data.page === 1 ? data.rows : [...state.brands, ...data.rows],
      infiniteScroll: {
        currentPage: data.page,
        nrOfPages: data.totalPages,
        hasMore: data.page < data.totalPages,
      },
    });
  };

  const loadNextPage = async filterParams => {
    const { currentPage, nrOfPages } = state.infiniteScroll;
    if (currentPage < nrOfPages) {
      const nextPage = currentPage + 1;
      await loadMoreBrands(filterParams, nextPage);
    }
  };

  useEffect(() => {
    setState({
      brands: initialBrands.rows,
      infiniteScroll: {
        currentPage: initialBrands.page,
        nrOfPages: initialBrands.totalPages,
        hasMore: initialBrands.page < initialBrands.totalPages,
      },
    });
  }, [initialBrands]);
  const { infiniteScroll, brands } = state;

  return (
    <>
      {!brands || brands.length === 0 ? (
        <SearchNoResult />
      ) : (
        <InfiniteScroll
          pageStart={0}
          loadMore={() => loadNextPage()}
          hasMore={infiniteScroll.hasMore}
        >
          <Row className="g-0">
            {brands.map(item => (
              <Col xs={6} sm={6} lg={3} key={item.id} className="p-1">
                <Link href={`/brands/${encodeURI(item.name)}`} passHref>
                  <Card>
                    <CardBody>
                      <Row>
                        <div className="text-center">
                          <Image
                            resX={160}
                            resY={90}
                            alt={item.name}
                            src={item.image}
                          />
                        </div>
                      </Row>
                      <Row className="text-center">
                        <Col>{item.name}</Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </InfiniteScroll>
      )}
    </>
  );
}

Brands.getInitialProps = async ({ req, querySpecification, pageConfig }) => {
  const brands = await getBrands(querySpecification, 1, req);

  return {
    initialBrands: brands,
    pageConfig,
  };
};

Brands.propTypes = {
  initialBrands: PropTypes.object.isRequired,
};

Brands.defaultProps = {};

export default Brands;
